import { useEffect, useContext } from 'react';
import _ from 'lodash';

import { GeneralContext } from '../../../core/app-context/GeneralContext';
import useGlobalStore from '../../../shared/store/globalStore';
import Services from '../services';

export default function useFetchConfigurationRules() {
  const { setErrorMessage } = useContext(GeneralContext);
  const store = useGlobalStore((state) => state.general.store);
  const fetched = useGlobalStore((state) => state.configurationRules.fetched);
  const setLoading = useGlobalStore(
    (state) => state.configurationRules.setLoading,
  );
  const setFetched = useGlobalStore(
    (state) => state.configurationRules.setFetched,
  );

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const configsAndRules = await Services.getStoreConfigsAndRules(
          store.id,
        );
        if (!configsAndRules) {
          return; //!
        }
        const returnReasons = configsAndRules.returnReasons.map((reason) => ({
          id: reason.id,
          isSelected: reason.isSelected,
          description: reason.description,
        }));
        const categories = configsAndRules.categories.map((category) => ({
          id: category.id,
          eligible: category.eligible,
          name: category.name,
        }));
        const storeConfigs = _.cloneDeep(configsAndRules.storeConfigs);
        delete storeConfigs.__typename;
        setFetched({
          returnReasons,
          categories,
          storeConfigs,
        });
      } catch (err) {
        setErrorMessage(
          'Não foi possível carregar as configurações da loja. Atualize a página e tente novamente.',
        );
      } finally {
        setLoading(false);
      }
    };
    if (
      !fetched.returnReasons ||
      !fetched.categories ||
      !fetched.storeConfigs
    ) {
      fetch();
    }
  }, []);
}
